
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MenuItemProps } from ".";
import { loading, endLoading, remove } from "store/menu";

interface ApiMenuRemoveInputProps {
    ids: number[]
}

type ApiMenuRemoveOutputProps = OutputBaseProps<{ item: MenuItemProps; }>

export const apiMenuRemove = async (data: ApiMenuRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiMenuRemoveOutputProps>("/api/menu/remove", { data }))
        .data;
    if (res.code === 0) {
        store.dispatch(remove(data));
    }
    store.dispatch(endLoading());
    return res;
};